export default {
  // Main menu
  menu: 'Menu',

  // Administrative Management
  administrativeManagement: 'Administrative Management',
  institution: 'Institution',
  users: 'Users',
  evaluations: 'Evaluations',

  // Resources
  alternativeNames: 'Alternative Names',
}
